import { IMAGE_URLS } from 'src/assets/urlLinks'
import { Avatar } from 'src/shared/components/ui/avatar'
import { cn } from 'src/shared/components/ui/utils'

export const TeamKlayderAvatar = ({ className }: { className?: string }) => (
  <Avatar
    size="sm"
    className={cn('mt-0.5 h-8 w-8 shrink-0 rounded-full border-0', className)}
  >
    <div className="flex h-full w-full items-center justify-center rounded-full bg-neutral-900">
      <img
        src={IMAGE_URLS.logos.klayderSymbol}
        alt=""
        className="h-[15px] w-auto"
      />
    </div>
  </Avatar>
)
